import axios from "axios";
import { AuthService } from "../../modules/auth/login-service";
import { saveReturnUrl } from "../../modules/auth/return-url";

function redirectToLogin() {
  saveReturnUrl();
  localStorage.clear();
  window.location.href = "/login";
}

const setupAxios = (onUnauthenticated) => {
  axios.defaults.baseURL = process.env.REACT_APP_BASEURL;
  // Axios request interceptor
  axios.interceptors.request.use(
    async (config) => {
      // Add the access token to the request headers (if available)
      const accessToken = localStorage.getItem("access_token");

      if (accessToken) {
        config.headers.Authorization = `Bearer ${accessToken}`;
      }

      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  // Axios response interceptor
  axios.interceptors.response.use(
    (response) => {
      return response;
    },
    async (error) => {
      // Handle authentication error (e.g., expired access token)
      if (error.response) {
        const originalConfig = error.config;
        if (error.response.status === 401 && !error.config._retry) {
          originalConfig._retry = true;
          const refreshTokenValue = localStorage.getItem("refresh_token");
          const usernameValue = localStorage.getItem("username");

          if (refreshTokenValue && usernameValue) {
            try {
              const refreshResponse = await AuthService.refreshToken(
                refreshTokenValue,
                usernameValue
              );
              if (refreshResponse) {
                if (refreshResponse.status === 400) {
                  onUnauthenticated();
                  redirectToLogin();
                  return Promise.reject(error);
                }
                const newAccessToken = refreshResponse.data.access_token;
                const newRefreshToken = refreshResponse.data.refresh_token;
                localStorage.setItem("access_token", newAccessToken);
                localStorage.setItem("refresh_token", newRefreshToken);
                error.config.headers.Authorization = `Bearer ${newAccessToken}`;

                // Retry the original request
                return axios(error.config);
              } else {
                onUnauthenticated();
                redirectToLogin();
              }
            } catch (refreshError) {
              onUnauthenticated();
              redirectToLogin();
            }
          } else {
            onUnauthenticated();
            redirectToLogin();
          }
        }
      }

      return Promise.reject(error);
    }
  );
};

export default setupAxios; // Export the configured Axios instance
